import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PermiteUsuarioSemCpfDto } from "../model/permite-usuario-sem-cpf-dto";

@Injectable({
  providedIn: "root",
})
export class PermiteUsuarioSemCpfService {
  private http = inject(HttpClient);

  private readonly BASE_URL = `./rest/usuario-sem-cpf/`;

  public getPodeCriarUsuarioSemCpf(cnpj: string, options?: {}): Observable<PermiteUsuarioSemCpfDto> {
    if (!cnpj) {
      throw "Qual o cnpj?";
    }
    return this.http.get<PermiteUsuarioSemCpfDto>(`${this.BASE_URL}${cnpj}`, options);
  }

  public setPodeCriarUsuarioSemCpf(
    cnpj: string | undefined,
    isHabilitado: boolean,
    options?: {},
  ): Observable<PermiteUsuarioSemCpfDto> {
    if (!cnpj) {
      throw "Qual o cnpj?";
    }
    const dto: PermiteUsuarioSemCpfDto = new PermiteUsuarioSemCpfDto(isHabilitado);
    return this.http.post<PermiteUsuarioSemCpfDto>(`${this.BASE_URL}${cnpj}`, dto, options);
  }
}
